import React from "react";
import css from "./section.module.css";
import { NavLink } from "react-router-dom";
import resources from "../../../../resources";
const Section1 = () => {
  return (
    <div className={css.wrapper}>
      <div className={css.section1}>
        <div className={css.left}>
          <div className={css.text}>
            <h2>Grow your Business & Customer Satisfaction with Quiety</h2>
            <p>
              Dynamically disintermediate technically sound technologies with
              compelling quality vectors error-free communities.
            </p>
            <div className={css.header_btn}>
              <NavLink>
                <button>Open Positions</button>
              </NavLink>
              <NavLink>
                <button className={css.meet}>Meet Out Team</button>
              </NavLink>
            </div>
          </div>

          <div className={css.img}>
            <img src={resources.images.about_sec1} />
          </div>
        </div>

        <div className={css.right}>
            <img className={css.img1} src={resources.images.about_sec1_3} />
            <img className={css.img2} src={resources.images.about_sec1_2} />
        </div>
      </div>

      <div className={css.bg_white}></div>
    </div>
  );
};

export default Section1;
